module.exports = __webpack_public_path__ + "605c7dc7517a1cb0511d7b4c76136980.svg";